module.exports = [
	{
		"componentChunkName": "page-component---node-modules-gatsby-plugin-offline-app-shell-js",
		"jsonName": "offline-plugin-app-shell-fallback.json",
		"path": "/offline-plugin-app-shell-fallback/"
	},
	{
		"componentChunkName": "page-component---src-templates-blog-page-js",
		"jsonName": "posts-composeable-web.json",
		"path": "/posts/composeable-web"
	},
	{
		"componentChunkName": "page-component---src-templates-blog-page-js",
		"jsonName": "about.json",
		"path": "/about"
	},
	{
		"componentChunkName": "page-component---src-pages-index-js",
		"jsonName": "index.json",
		"path": "/"
	},
	{
		"componentChunkName": "page-component---src-pages-projects-js",
		"jsonName": "projects.json",
		"path": "/projects/"
	}
];


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = ./.cache/pages.json
// module chunks = 11